class RelatedProducts extends window.MDLR.CustomElement {
  static get requiredAttributes() {
    return ["data-url"];
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.wrapper) {
      this.initCarousel();
      return;
    }

    this.initObserver();
  }

  disconnectedCallback() {
    this.destroyObserver();
    this.destroyCarousel();
    super.disconnectedCallback();
  }

  initObserver() {
    if (this.observer) return;

    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0]?.isIntersecting) return;

        observer.unobserve(this);
        this.destroyObserver();
        this.fetchRecommendations();
      },
      {
        rootMargin: "0px 0px 200px 0px",
      },
    );

    this.observer.observe(this);
  }

  destroyObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
  }

  async fetchRecommendations() {
    const url = this.getAttribute("data-url");
    if (!url) return;

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations =
        html.querySelector("related-products") ||
        html.querySelector(".related-products");

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        requestAnimationFrame(() => this.initCarousel());
      }
    } catch (error) {
      console.error(error);
    }
  }

  initCarousel() {
    if (this.emblaApi || !this.wrapper) return;

    const Embla = window.EmblaCarousel;
    if (!Embla) {
      window.addEventListener("load", () => this.initCarousel(), {
        once: true,
      });
      return;
    }

    const options = {
      loop: true,
      align: "start",
    };

    const plugins = [];
    if (window.EmblaCarouselWheelGestures) {
      plugins.push(window.EmblaCarouselWheelGestures());
    }

    this.emblaApi = Embla(this.wrapper, options, plugins);
  }

  destroyCarousel() {
    if (!this.emblaApi) return;
    this.emblaApi.destroy();
    this.emblaApi = null;
  }

  get wrapper() {
    return this.getElement("wrapper");
  }
}

if (!customElements.get("related-products")) {
  customElements.define("related-products", RelatedProducts);
}
